<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
body{
  margin: 0!important;
  // display: flex;
  // justify-content: center;
  // background: #fce7de;
  background: #fcf2ee;
  // width: 100%;
  // display: flex;
  // justify-content: center;
}
//1510
@media (min-width: 1510px){//大于
  // body{
  //   display: flex;
  //   justify-content: center;
  // }
}
.row{
  display: flex;
  flex-direction: row;
}
.col{
  display: flex;
  flex-direction: column;
}
.spacbet{
  justify-content: space-between;
}
.el-pagination.is-background .el-pager li {
  background: none!important;
}

.el-pagination.is-background .btn-prev{
  background-color: transparent!important;
}
.el-pagination.is-background .btn-next{
  background-color: transparent!important;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #ff7a2d!important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff7a2d!important;
  color: #FFF!important;
  // border-radius: 50%;
}
//在style里面添加此段代码即可
 
input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
input[type="number"]{
    -moz-appearance: textfield;
}
// /deep/ input::-webkit-outer-spin-button,
// /deep/ input::-webkit-inner-spin-button {
//   -webkit-appearance: none !important;
// }
// /deep/ input[type="number"] {
//   -moz-appearance: textfield !important;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue